import React from 'react';
import { Box } from '@mui/material';
import PlayCircleFilledIcon from '@mui/icons-material/PlayCircleFilled';

export interface VideoMediaBadgeProps {
   /** Icon diameter in px (default 52 for grid tiles) */
   iconSize?: number;
   zIndex?: number;
}

/**
 * Centered play affordance for video thumbnails — photos do not use this overlay.
 */
export function VideoMediaBadge({ iconSize = 52, zIndex = 1 }: VideoMediaBadgeProps) {
   return (
      <Box
         aria-hidden
         sx={{
            position: 'absolute',
            inset: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            pointerEvents: 'none',
            zIndex,
         }}
      >
         <Box
            sx={{
               display: 'flex',
               alignItems: 'center',
               justifyContent: 'center',
               borderRadius: '50%',
               bgcolor: 'rgba(0,0,0,0.4)',
               p: 0.25,
            }}
         >
            <PlayCircleFilledIcon
               sx={{
                  fontSize: iconSize,
                  color: 'rgba(255,255,255,0.96)',
                  filter: 'drop-shadow(0 2px 10px rgba(0,0,0,0.55))',
               }}
            />
         </Box>
      </Box>
   );
}
